<template>
  <div class="main-page page-service">
    <Menu :title="title"
          :home="false"
          :location="false"></Menu>
    <div class="container-flex">
      <section class="video-container">
        <div class="video-panel">

          <div class="video-div">
            <video controls
                   controlslist="nodownload"
                   id="videopanel3"
                   ref="videopanel3"
                   class="video5"
                   :poster="currentVideo.img || '/img/banner/bg_video.jpg'"
                   webkit-playsinline="true">
              <source :src="currentVideo.src"
                      type="video/mp4">
            </video>
          </div>
          <div class="knowledge-contest"
               @click="toKnowledgeContest">
            <img width="100%"
                 src="https://qiniu.laway.cn/yn/2022/10/28/7c138648566b11ed9d43b4055d0b07be.png">
          </div>
        </div>
        <div class="box-container">
          <div class="box"
               @click="handleGoFa">
            <img src="/img/ui/mfd/mfd_cx.png"
                 alt="">
            <div class="box-title">
              <p class="p-title">民法典法律法规查询</p>
              <p>懂法用法，依法维权</p>
            </div>
          </div>
          <div class="box"
               @click="handleGoDong">
            <img src="/img/ui/mfd/mfd_dt.png"
                 alt="">
            <div class="box-title">
              <p class="p-title">民法资讯动态</p>
              <p>了解前沿动态，永不落伍</p>
            </div>
          </div>
          <div class="box"
               @click="slide.show=true">
            <img src="/img/ui/mfd/mfd_sp.png"
                 alt="">
            <div class="box-title">
              <p class="p-title">民法典视频宣传</p>
              <p>查看全部视频列表</p>
            </div>
          </div>
        </div>
      </section>
      <p>《中华人民共和国民法典》被称为“社会生活的百科全书”，是新中国第一部以法典命名的法律，在法律体系中居于基础性地位，也是市场经济的基本法。《中华人民共和国民法典》共7编、1260条，各编依次为总则、物权、合同、人格权、婚姻家庭、继承、侵权责任，以及附则。</p>

    </div>
    <Rightslide v-model="slide"
                @getClose="getClose">
      <template slot="content">
        <div class="video-list">
          <div class="hts">民法典视频</div>
          <ul>
            <li v-for="(item, index) in videoList"
                :key="'key-'+index"
                @click="playVideo(item, index)">
              <a href="javascript:;">
                <img :src="item.img"
                     alt
                     style="object-fit:cover;">
                <strong class="video-title">{{item.title}}</strong>
                <p>{{item.date}} ∙ {{item.view_count}}次浏览</p>
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template slot="footer">
        <div class="btns yel"
             @click="getClose">
          <button>返回</button>
        </div>
      </template>
    </Rightslide>
  </div>
</template>
<script>
import Menu from '../components/Menu'
import Rightslide from '@/components/RightSlide'
import { MINFADIAN, MINFADIAN_KNOWLEDGE_CONTEST } from '@/datas/constants/statistics.js'

export default {
  components: {
    Menu,
    Rightslide
  },
  data () {
    return {
      title: '民法典专题',
      currentVideo: '',
      videoList: [],
      slide: {
        show: false
      },
      alert: {
        show: false,
        info: '',
        recall: () => { }
      },
    }
  },
  mounted () {
    this.$root.getStatistics(MINFADIAN)
    this.getVideoList()
  },
  methods: {
    playVideo (item, index) {
      this.slide.show = false
      this.currentVideo = Object.assign(item, { index })
      this.$nextTick(() => {
        document.querySelector('#videopanel3').src = item.video
        document.querySelector('#videopanel3').play()
      })
    },
    async getVideoList () {
      const { result: { data } } = await this.$get('pufa/api/post/list/?per_page=50&diagram_id=5ef7f8199748ca19b444da6f')
      this.$nextTick(() => {
        // document.querySelector('#videopanel3').style = 'object-fit: cover;'
        this.videoList.push(...data.items)
        this.currentVideo = this.videoList.length ? Object.assign(this.videoList[0], { index: 0 }) : ''
        document.querySelector('#videopanel3').src = this.currentVideo.video

        document.querySelector('#videopanel3').addEventListener('ended', () => {
          /**
           * 监听到播放结束后
           * 自动切换下一个视频
           * 以下为边界判断
           * 视频列表不能为空，视频只有一条时加上循环播放
           * 视频列表大于1条时，loop整个视频列表
           * currentVideo作为对象进行存储，提供暂停时需要的信息展示
           */
          if (this.videoList.length === 1) {
            document.querySelector('#videopanel3').loop = 'loop'
            // document.querySelector('#videopanel2').loop = 'loop'
          } else {
            const idx = this.currentVideo.index + 1 === this.videoList.length ? 0 : this.currentVideo.index + 1
            this.currentVideo = Object.assign(this.videoList[idx], { index: idx })
            document.querySelector('#videopanel3').src = this.currentVideo.video
          }
        }, false)
      })
    },
    getClose () {
      this.slide.show = false
    },
    async loadMore () {
      if (this.pagemax) return
      this.getList(this.page + 1)
    },
    handleGoFa () {
      this.$router.push({
        name: 'LawDetail',
        params: { id: '2890149153244E518DE91EB52FDABEA3' }
      })
    },
    handleGoDong () {
      this.$router.push('/pufa?title=民法典资讯动态&id=5ef7f80f9748ca19b444da62')
    },
    toKnowledgeContest () {
      this.$root.getStatistics(MINFADIAN_KNOWLEDGE_CONTEST)
      const code = this.$store.state.device.point.code
      const machineId = this.$store.state.device.point.no
      window.location.href = `${this.appSite}/terminal/contest?code=${code}&machineId=${machineId}&id=245C5E4D4A1A4751BCAFE7707C88B930`
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-service
  .container-flex
    padding 0.15rem 2.92rem
    p
      color #fff
  .video-container
    display flex
    justify-content space-between
    align-items center
    margin-bottom 0.3rem
    .video-panel
      width 9.6rem
      margin-right 0.2rem
      .knowledge-contest
        height 2rem
        img
          display block
      .video-div
        height 5.3rem
        border-radius 0.1rem
        background-color rgba(255, 255, 255, 0.08)
        overflow hidden
        margin-bottom 0.15rem
        video
          width 100%
          height 5.3rem
          z-index 88
    .box-container
      display flex
      flex-direction column
      justify-content space-between
      .box
        display flex
        flex-direction column
        align-items center
        width 3.6rem
        height 2.34rem
        border-radius 0.1rem
        background-color rgba(255, 255, 255, 0.08)
        border 1px solid rgba(255, 255, 255, 0.2)
        &:not(:last-child)
          margin-bottom 0.2rem
        img
          width 1.16rem
          height 1.16rem
          margin 0.2rem 0 0.15rem
        .p-title
          font-size 0.24rem
          margin-bottom 0.1rem
          font-weight bold
        p
          text-align center
          font-size 0.16rem
.video-list
  padding 0.3rem 0 0 0.3rem
  .hts
    font-size 0.36rem
    font-weight bold
  ul
    display flex
    flex-wrap wrap
    padding 0.3rem 0
    li
      width 50%
      margin-bottom 0.3rem
      a
        display block
        margin-right 0.3rem
        color #333
        img
          width 100%
          min-height 2.1rem
          max-height 2.1rem
          border-radius 0.1rem
          overflow hidden
          display block
        strong
          padding-top 0.2rem
          font-size 0.24rem
          display -webkit-box
          -webkit-box-orient vertical
          -webkit-line-clamp 1
          overflow hidden
        p
          padding-top 0.1rem
          font-size 0.18rem
          color #666666
</style>
